angular.module("ticketco/ticketbuyer/gift_cards").constant("GiftCardsDialogs", {
  addGiftCard: {
    name: "addGiftCard",
    template: "addGiftCardDialog.html",
    className: "ngdialog-theme-default recaptched",
  },
  addVoucher: {
    name: "addVoucher",
    template: "addVoucherDialog.html",
    className: "ngdialog-theme-default recaptched",
  },
});
